import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { catchError, Observable, of, shareReplay } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { Language } from '../models/language.interface';

@Injectable({ providedIn: 'root' })
export class LanguagesService {
  private http = inject(HttpClient);
  private languages$ = this.http.get<Language[]>(`${this.environment.surveyEndPoint}languages`).pipe(
    catchError(() => of([])),
    shareReplay()
  );

  constructor(@Inject('environment') private environment: EnvironmentConfig) {}

  getAll(): Observable<Language[]> {
    return this.languages$;
  }
}
